import React, {useState, useEffect} from 'react';
import './textTag.scss'

const TextTag = (props) => {
    const faceList = [
        {text: '默认', value: 'default'},
        {text: '微笑', value: '(light smile:1.3)'},
        // {text: '露齿笑', value: '(grin:1.3)'},
        // {text: '自然', value: '(expressionless:1.3)'}
    ]
    const hairList = [
        {text: '默认', value: 'default'},
        {text: '短发', value: '(short hair:1.3)'},
        {text: '长发', value: '(long hair:1.3)'},
        {text: '直发', value: '(straigth hair:1.3)'},
        {text: '卷发', value: '(curly hair:1.3)'},
        // {text: '大波浪', value: '(wavy hair:1.3)'},
        // {text: '单马尾', value: '(ponytail:1.3)'},
        {text: '马尾', value: '(twintails:1.3)'},
        // {text: '丸子头（单）', value: '(hair bun:1.3)'},
        {text: '丸子头', value: '(double bun:1.3)'},
        {text: '齐刘海', value: '(blunt bangs:1.3)'}
    ]


    const faceTagChange = (value, text) => {
        props.faceTagChange(value, text)
    }

    const hairTagChange = (value, text) => {
        props.hairTagChange(value, text)
    }

    return (
        <div className='textTag'>
            <div>
                <div className='title_'>表情</div>
                <p>
                    {
                        faceList.map((item) => {
                            return <span className={props.faceTag == item.value?'select_sty': null} onClick={() => faceTagChange(item.value, item.text)} key={item.value}>{item.text}</span>
                        })
                    }
                </p>
                
            </div>
            <div>
                <div className='title_'>发型</div>
                <p>
                    {
                        hairList.map((item) => {
                            return <span className={props.hairTag == item.value?'select_sty': null} onClick={() => hairTagChange(item.value, item.text)} key={item.value}>{item.text}</span>
                        })
                    }
                </p>
               
            </div>
        </div>
    )
}

export default TextTag